import * as React from 'react';
import { Box } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface Props {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
  onBackgroundClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  border?: boolean;
}

const PrimaryLightBgCard = ({
  children,
  sx,
  className,
  onBackgroundClick,
  border,
}: Props) => {
  const backgroundClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    if (onBackgroundClick) {
      onBackgroundClick(event);
    }
  };

  return (
    <Box
      sx={[
        {
          backgroundColor: (theme) => theme.palette.background.default,
          borderRadius: '6px',
          p: 2,
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: (theme) => theme.palette.primary.light,
        },
        ...(border ? [{ borderColor: 'primary.main', borderWidth: '1px', borderStyle: 'solid' }] : []),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      className={`${className}`}
      component="div"
      onClick={backgroundClickHandler}
    >
      {children}
    </Box>
  );
};

PrimaryLightBgCard.defaultProps = {
  sx: [],
  className: '',
  onBackgroundClick: () => {},
  border: false,
};

const WhiteBgCard = ({
  children,
  sx,
  className,
  onBackgroundClick,
  border,
}: Props) => {
  const backgroundClickHandler = (event: React.MouseEvent<HTMLDivElement>) => {
    if (onBackgroundClick) {
      onBackgroundClick(event);
    }
  };
  return (
    <Box
      sx={[
        {
          backgroundColor: (theme) => theme.palette.background.paper,
          borderRadius: '6px',
          padding: { xs: '15px 16px', sm: '20px 24px' },
          boxShadow: '0px 8px 60px #00000005',
        },
        ...(border ? [{ borderColor: 'primary.dark', borderWidth: '1px', borderStyle: 'solid' }] : []),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      className={`${className}`}
      component="div"
      onClick={backgroundClickHandler}
    >
      {children}
    </Box>
  );
};

WhiteBgCard.defaultProps = {
  sx: [],
  className: '',
  onBackgroundClick: () => {},
  border: false,
};

export { PrimaryLightBgCard, WhiteBgCard };
